import { render, staticRenderFns } from "./NewWordFile.vue?vue&type=template&id=597cacfe&"
import script from "./NewWordFile.vue?vue&type=script&lang=js&"
export * from "./NewWordFile.vue?vue&type=script&lang=js&"
import style0 from "./NewWordFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports